module.exports = __webpack_public_path__ + "img/blog-7.3468fc79.jpg";